import React from "react";
import { Button, Grid, Modal } from "@mui/material";
import { Box } from "@mui/system";

import ErrorIcon from "@mui/icons-material/Error";

import { modalStyle } from "../../../constant";
import { healthRecordsStyles } from "../../healthRecords/styles/healthRecordsStyles";
import { messagingStyles } from "../styles/messagingStyles";
import { useTranslation } from "react-i18next";

const ErrorModal = ({ modalOpen, handleClose, matchesSM, matchesXS }) => {
  const {t} = useTranslation("translations")
  return (
    <Modal open={modalOpen} onClose={handleClose}>
      <Box
        sx={{
          ...modalStyle,
          width: matchesSM || matchesXS ? "60%" : 456,
        }}
      >
        <Grid
          container
          direction={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          style={{ padding: matchesSM || matchesXS ? "0px" : "0px 80px" }}
        >
          <ErrorIcon style={messagingStyles.errorIcon} />
          <span style={messagingStyles.modalTitleStyles}>
            {t("something_went_wrong")}
          </span>
          <span style={messagingStyles.modalSubTitleStyles}>
            {t("couldnt_send_your_message")}
          </span>
          <Button
            fullWidth
            variant="contained"
            onClick={handleClose}
            style={healthRecordsStyles.okayButtonStyles}
          >
            {t("try_again")}
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ErrorModal;
